import colors from 'vuetify/es5/util/colors';

class ThemeColors {
    public static readonly PRIMARY: string = '#1c70f2';
    public static readonly SECONDARY: string = '#ec5f00';
    public static readonly TERTIARY: string = '#ec5f00';
    public static readonly ACCENT: string = '#ec5f00';
    public static readonly ERROR: string = colors.red.darken4;
    public static readonly INFO: string = '#2196F3';
    public static readonly SUCCESS: string = '#4CAF50';
    public static readonly WARNING: string = '#FFC107';
}

export default ThemeColors;
